<div *ngIf="formFieldsData && form && !!formFields">
  <form [formGroup]="form" (submit)="presentPriceModal()">
    <ng-container *ngFor="let formfield of formFields; let ind = index">
      <div [ngClass]="formFields.length > 1 ? 'form-container' : ''">

        <div class="header" *ngIf="formFields.length > 1">
          {{ getPassengerTitle(formfield[0]) }}
        </div>
        <div>
          <ion-button
            expand="block"
            class="ion-margin-bottom outline-btn"
            [ngClass]="formFields.length > 1 ? 'form-group' : ''"
            [disabled]="isGuestListModalOpen"
            (click)="selectfromGuestList(formfield[0])"
          >
            <ion-icon name="people-outline" slot="start"></ion-icon>
            <span class="fs-3 font500" slot="start">
              {{ "hotel.booking_review.select_guest" | translate }}
            </span>
          </ion-button>
        </div>
        <div
          *ngFor="let item of formfield[1]; let i = index"
          [ngClass]="formFields.length > 1 ? 'form-group' : ''"
        >
          <div
            class="ion-margin-bottom"
            *ngIf="item.type === 'text' && item.name !== 'calling_code'"
          >
            <ion-input
              [label]="item.label"
              labelPlacement="floating"
              autocomplete="off"
              [name]="item['name']"
              [type]="item['type']"
              [required]="item?.rules?.required"
              [formControlName]="formfield[0] + '+' + i + '+' + item['name']"
              [readonly]="item.name === 'tour_time'"
              class="primary-input text-input"
            >
            </ion-input>
          </div>
          <div class="ion-margin-bottom" *ngIf="item.type === 'email'">
            <ion-input
              [label]="item.label"
              labelPlacement="floating"
              autocomplete="off"
              [name]="item['name']"
              [type]="item['type']"
              [placeholder]="item.placeholder"
              [required]="item?.rules?.required"
              [formControlName]="formfield[0] + '+' + i + '+' + item['name']"
              class="primary-input text-input"
            >
            </ion-input>
          </div>
          <div
            *ngIf="
              item.name === 'phone_number' || item.name === 'mobile_number'
            "
            class="ion-margin-bottom input-border padt6"
          >
            <ion-label class="fs-2 font400 padl10">{{ item.label }}</ion-label>
            <div class="d-flex ion-align-items-center">
              <ion-button
                (click)="selectCountryCode(formfield[0])"
                class="fs-3 ion-no-margin ion-no-padding padl10 clear-btn d-flex calling-code-btn"
                *ngIf="isCallingCode"
              >
                <span>{{ selectedCountryCode[formfield[0]].flag }}</span>
                <span> {{ selectedCountryCode[formfield[0]].dialCode }}</span>
                <ion-icon
                  class="fs-4 primary-icon-color padr5"
                  slot="end"
                  name="chevron-down-outline"
                ></ion-icon>
              </ion-button>
              <ion-input
                autocomplete="off"
                [name]="item['name']"
                [type]="item['type']"
                [placeholder]="item.placeholder"
                [required]="item?.rules?.required"
                [formControlName]="formfield[0] + '+' + i + '+' + item['name']"
                class="primary-input mobile-input"
              >
              </ion-input>
            </div>
          </div>
          <div
            class="ion-margin-bottom"
            *ngIf="
              item.type === 'number' &&
              item.name !== 'phone_number' &&
              item.name !== 'mobile_number'
            "
          >
            <ion-input
              [label]="item.label"
              labelPlacement="floating"
              autocomplete="off"
              [name]="item['name']"
              [type]="item['type']"
              [placeholder]="item.placeholder"
              [required]="item?.rules?.required"
              [formControlName]="formfield[0] + '+' + i + '+' + item['name']"
              class="primary-input text-input"
            >
            </ion-input>
          </div>
          <div class="ion-margin-bottom" *ngIf="item.type === 'textarea'">
            <ion-textarea
              autocomplete="off"
              class="text-area"
              [name]="item['name']"
              [placeholder]="item.placeholder"
              [required]="item?.rules?.required"
              [formControlName]="formfield[0] + '+' + i + '+' + item['name']"
              class="primary-input textarea-container ion-padding-start"
            >
            </ion-textarea>
          </div>
          <div class="ion-margin-bottom" *ngIf="item.type === 'date'">
            <ion-input
              [name]="item['name']"
              [type]="item['type']"
              [label]="item.label"
              labelPlacement="floating"
              [placeholder]="item.placeholder"
              [required]="item?.rules?.required"
              [min]="
                item['name'] === 'checkout' ? checkoutMinDate : item?.rules?.min
              "
              [max]="
                item.name === 'date_of_birth' || item.name === 'dob'
                  ? item?.rules?.max || validBdate
                  : ''
              "
              (change)="onDateChange($event)"
              [formControlName]="formfield[0] + '+' + i + '+' + item['name']"
              class="primary-input text-input"
            >
              <div slot="label" class="date-label">{{ item.label }}</div>
            </ion-input>
          </div>
          <div class="ion-margin-bottom" *ngIf="item.type === 'time'">
            <ion-input
              name="item['name']"
              [type]="item['type']"
              [label]="item.label"
              labelPlacement="floating"
              [placeholder]="item.placeholder"
              [required]="item?.rules?.required"
              [formControlName]="formfield[0] + '+' + i + '+' + item['name']"
              class="primary-input text-input"
            >
              <ion-label slot="label" class="time-label">{{
                item.label
              }}</ion-label>
            </ion-input>
          </div>
          <div
            class="ion-margin-bottom ion-text-capitalize"
            *ngIf="item.type === 'options' && item.name === 'terminal'"
          >
            <ion-select
              class="ion-no-padding primary-select select-custom-icon"
              [label]="item.label"
              labelPlacement="floating"
              [placeholder]="item.placeholder"
              [required]="item?.rules?.required"
              [formControlName]="formfield[0] + '+' + i + '+' + item['name']"
              interface="popover"
            >
              <!-- [(ngModel)]="targetLocation" -->
              <ion-select-option
                class="ion-text-capitalize"
                *ngFor="
                  let element of locationOptions && locationOptions.length
                    ? locationOptions
                    : item.options
                "
                [value]="element"
                >{{ element }}</ion-select-option
              >
            </ion-select>
          </div>
          <div
            class="ion-margin-bottom"
            *ngIf="
              item.type === 'options' &&
              item.name !== 'terminal' &&
              item.name !== 'tour_time'
            "
          >
            <ion-select
              class="primary-select ion-no-padding ion-text-capitalize select-custom-icon"
              [label]="item.label"
              labelPlacement="floating"
              [placeholder]="item.placeholder"
              [required]="item?.rules?.required"
              [formControlName]="formfield[0] + '+' + i + '+' + item['name']"
              interface="popover"
            >
              <ion-select-option
                *ngFor="let element of item.options"
                class="ion-text-capitalize"
                value="{{ element }}"
                >{{ element }}</ion-select-option
              >
            </ion-select>
          </div>
          <div
            class="ion-margin-bottom"
            *ngIf="
              item.type === 'options' &&
              item.name === 'tour_time' &&
              visitTimeOptions &&
              visitTimeOptions.length > 0
            "
          >
            <ion-select
              class="primary-select ion-no-padding ion-text-capitalize select-custom-icon"
              [label]="item.label"
              labelPlacement="floating"
              [placeholder]="item.placeholder"
              [required]="item?.rules?.required"
              [formControlName]="formfield[0] + '+' + i + '+' + item['name']"
              interface="popover"
            >
              <ion-select-option
                *ngFor="let element of visitTimeOptions"
                class="ion-text-capitalize"
                value="{{ element }}"
                >{{ element }}</ion-select-option
              >
            </ion-select>
          </div>
          <div class="ion-margin-bottom" *ngIf="item.type === 'file'">
            <ion-button
              mode="ios"
              expand="block"
              class="white-btn mar0 file-upload-btn fs-4 font500"
              (click)="fileUploadInput.click()"
              [ngClass]="{
                'success-upload': fileInputs?.[formfield[0] + '+' + i + '+' + item.name]?.name,
                'error-upload': fileInputsError?.[formfield[0] + '+' + i + '+' + item.name],
                'error-upload-border': form.get(formfield[0] + '+' + i + '+' + item['name'])?.invalid &&
                form.get(formfield[0] + '+' + i + '+' + item['name'])?.touched
              }"
            >
              <div class="d-flex flex-col">
                <span>
                  Upload {{ item?.label }}
                  <ion-icon
                    slot="end"
                    class="v-middle-icon"
                    [name]="fileInputs?.[formfield[0] + '+' + i + '+' + item.name]?.name ? 'cloud-done-outline' : 'cloud-upload-outline'"
                  ></ion-icon>
                </span>
                <span
                  class="fs-1 font400"
                  *ngIf="fileInputs?.[formfield[0] + '+' + i + '+' + item.name]"
                >
                  {{
                    fileInputs[formfield[0] + "+" + i + "+" + item.name].name
                  }}
                </span>
              </div>
              <input
                [type]="item.type"
                [required]="item?.rules?.required"
                [accept]="item?.rules?.supportedTypes"
                [formControlName]="formfield[0] + '+' + i + '+' + item['name']"
                #fileUploadInput
                (change)="
                  onFileChange($event, formfield[0] + '+' + i + '+' + item.name)
                "
                style="display: none"
              />
            </ion-button>
            <div
              *ngIf="fileInputsError?.[formfield[0] + '+' + i + '+' + item.name] || 
                     (form.get(formfield[0] + '+' + i + '+' + item['name'])?.invalid && 
                      form.get(formfield[0] + '+' + i + '+' + item['name'])?.touched)"
              class="error-message mart4"
            >
              <ion-text color="danger" class="fs-2">
                <span
                  *ngIf="fileInputsError?.[formfield[0] + '+' + i + '+' + item.name]; else defaultError"
                >
                  {{
                    fileInputsError[formfield[0] + "+" + i + "+" + item.name]
                  }}
                </span>
                <ng-template #defaultError>
                  <span
                    *ngIf="form.get(formfield[0] + '+' + i + '+' + item['name'])?.errors?.['required']"
                  >
                    {{ item.label }} is required
                  </span>
                  <span
                    *ngIf="form.get(formfield[0] + '+' + i + '+' + item['name'])?.errors?.['fileSizeError']"
                  >
                    File size exceeds the limit
                  </span>
                  <span
                    *ngIf="form.get(formfield[0] + '+' + i + '+' + item['name'])?.errors?.['fileTypeError']"
                  >
                    Invalid file type
                  </span>
                </ng-template>
              </ion-text>
            </div>
          </div>
          <ion-item
            *ngIf="
              item.type === 'multicolumn-dropdown' && !isMultiPax
            "
            lines="none"
            class="input-container ion-margin-bottom select-guest"
            (click)="presentPicker(item)"
          >
            <ion-label
              [ngClass]="
            !qtyStringArray?.[item.name] ? 'ion-label-light' : 'ion-label-dark'
          "
              >{{ qtyStringArray?.[item.name] || "Select Guests" }}</ion-label
            >
            <ion-icon
              slot="end"
              name="caret-down-outline"
              class="primary-icon-color"
            ></ion-icon>
          </ion-item>
        </div>
      </div>
    </ng-container>
    <div
      class="save-guest-checkbox-container ion-bg-white d-flex ion-align-items-start ion-margin-top ion-margin-bottom"
      lines="none"
    >
      <ion-checkbox
        slot="start"
        class="ion-no-margin marr10 white-border-checkbox"
        [checked]="saveGuest"
        (ionChange)="saveGuest = $event.detail.checked"
        aria-label="agree"
        (click)="saveGuestCheckboxClick()"
      ></ion-checkbox>
      <ion-label
        class="fs-2 font500 ion-no-padding ion-no-margin l-height19 card-primary-text-color"
      >
        {{ "hotel.booking_review.save_guest" | translate }}
      </ion-label>
    </div>
    <ng-container
      *ngIf="offersObject?.offers && offersObject?.offers?.length > 0"
    >
      <ng-container *ngIf="!isOfferApplied; else offerApplied">
        <ion-button
          class="secondary-btn ion-margin-top apply-offer"
          expand="block"
          (click)="ShowOffers()"
        >
          <div class="btn_container">
            <p class="fs-2 font600">
              {{ "offer_card.apply_offer" | translate }}
            </p>
            <ion-icon name="chevron-forward-outline"></ion-icon>
          </div>
        </ion-button>
      </ng-container>

      <ng-template #offerApplied>
        <div>
          <ion-card
            lines="none"
            class="border-r10 ion-no-margin ion-margin-top card-white-background-color offer-card"
          >
            <div class="ion-padding">
              <div class="offer-card-title marb5">
                <div class="title-text">
                  <ion-icon
                    name="checkmark-circle"
                    class="primary-icon-color"
                  ></ion-icon>
                  <ion-text
                    class="fs-3 font700 ion-no-padding card-primary-text-color"
                  >
                    {{ "offer_card.offer_applied" | translate }}
                  </ion-text>
                </div>
                <ion-button
                  *ngIf="offersObject?.offers?.length > 1"
                  class="fs-2 font600 ion-float-end mar0 clear-btn view-offer-btn"
                  (click)="ShowOffers()"
                >
                  {{ "offer_card.view_offers" | translate }}
                </ion-button>
              </div>
              <div class="offer-card-content padt5">
                <p
                  class="fs-3 font600 ion-no-padding card-primary-text-color mar0 padr5"
                >
                  {{ selectedOfferTitle }}
                </p>
                <ion-icon
                  *ngIf="offersObject?.defaultOfferId && campaignId !== offersObject?.defaultOfferId"
                  name="trash-outline"
                  class="ion-float-right primary-icon-color trash-icon mar5"
                  (click)="removeOffer()"
                ></ion-icon>
              </div>
            </div>
          </ion-card>
        </div>
      </ng-template>
    </ng-container>
    <ng-template *ngIf="catlogType === 'flight_book'">
      <div [id]="userType !== 'premium' && 'open-modal'">
        <ion-item
          class="checkbox-container"
          [ngClass]="
            userType === 'premium' ? 'checkbox-enable' : 'checkbox-disable'
          "
        >
          <ion-checkbox
            slot="start"
            class="ion-no-margin marr10 secondary-checkbox"
            [disabled]="userType !== 'premium'"
            (ionChange)="checkboxfield($event)"
            [checked]="userType === 'premium'"
          ></ion-checkbox>
          <ion-label class="fs-4 font500 checkbox-text">{{
            "dynamic_form.reedem_subscription" | translate
          }}</ion-label>
          <custom-icon
            *ngIf="userType !== 'premium'"
            class="lock-img"
            iconName="lock"
            [width]="13"
            [height]="18"
          ></custom-icon>
        </ion-item>
        <ion-modal #modal trigger="open-modal" [cssClass]="'center'">
          <ng-template>
            <ion-content class="ion-bg-white">
              <ion-toolbar class="ion-bg-white">
                <ion-buttons slot="end">
                  <ion-button (click)="modal.dismiss()">
                    <ion-icon name="close" color="primary"> </ion-icon>
                  </ion-button>
                </ion-buttons>
              </ion-toolbar>
              <div class="img-container">
                <img src="assets/icons/premiumBatch.gif" />
              </div>
              <p class="fs-4 font500 ion-text-center text-color">
                {{ "dynamic_form.upgrade_subscription" | translate }}
              </p>
            </ion-content>
          </ng-template>
        </ion-modal>
      </div>
    </ng-template>
    <div class="submit_btn">
      <ion-button
        mode="ios"
        type="submit"
        class="ion-margin-top send_request bg-white fs-3 font500"
        *ngIf="formFieldsData"
        [ngClass]="form?.valid && campaignId ? 'primary-btn ' : 'secondary-btn'"
        [disabled]="!form?.valid || !campaignId"
        fill="solid"
        expand="block"
      >
        {{
          catlogType === "flight_book"
            ? ("dynamic_form.add" | translate)
            : ("dynamic_form.send_request" | translate)
        }}
      </ion-button>
    </div>
  </form>
</div>
